import { useSelector } from 'react-redux';
import * as React from 'react';
import { Documents } from '../../components/Documents';
import { ExpandButton } from '../../components/ExpandButton';
import { selectBuilderId } from '../../selectors/builder/selectBuilderId';
import { trackDocumentClick } from './tracking';
import { useDocumentsList } from './hooks/useDocumentsList';

export const DocumentsContainer = () => {
  const builderId = useSelector(selectBuilderId);

  const { list, expandable, inColumn, expanded, toggleExpanded } = useDocumentsList();

  const handleDocumentClick = React.useCallback(
    (url: string) => {
      trackDocumentClick(builderId, url);
    },
    [builderId],
  );

  if (!list.length) {
    return null;
  }

  return (
    <Documents
      items={list}
      onDocumentClick={handleDocumentClick}
      expandButton={
        expandable ? <ExpandButton expanded={expanded} onToggle={toggleExpanded} expandText="Ещё документы" /> : null
      }
      inColumn={inColumn}
    />
  );
};
